import React from "react"
import { Navigate, useLocation } from "react-router-dom"

import { FEATURES_TYPE, ONE_WAY_ROUTES } from "@constants"
import AppLayout from "Layout"
import OneWayAnalyzer from "Pages/AnalyzersV2/OneWay"
import AcrissGroupsPage from "Pages/OneWay/AcrissGroups"
import { OneWaysReports } from "Pages/ReportsAlerts/Reports"
import GroupingExportsPage from "Pages/ReportsAlerts/ExportsGrouping"


function RedirectWithSearch({ to }) {
	const { search } = useLocation()

	return <Navigate to={`${to}${search}`} replace/>
}

export const OneWayRoutes = userData => {
	if (!userData?.featuresV2?.[FEATURES_TYPE.ONE_WAY]) return []

	return [{
		id: FEATURES_TYPE.ONE_WAY,
		path: ONE_WAY_ROUTES.PATH,
		title: ONE_WAY_ROUTES.TITLE,
		icon: 'arrow-right-arrow-left',
		element: <AppLayout/>,
		children: [{
			element: <Navigate to={ONE_WAY_ROUTES.REPORTS_PATH} replace/>, index: true
		}, {
			path: ONE_WAY_ROUTES.REPORTS_PATH,
			title: ONE_WAY_ROUTES.REPORTS_TITLE,
			element: <OneWaysReports/>,
		}, {
			path: ONE_WAY_ROUTES.ANALYZER_PATH,
			title: ONE_WAY_ROUTES.ANALYZER_TITLE,
			element: <OneWayAnalyzer/>,
		}, {
			path: ONE_WAY_ROUTES.ACRISS_GROUPS_PATH,
			title: ONE_WAY_ROUTES.ACRISS_GROUPS_TITLE,
			element: <AcrissGroupsPage/>,
		}, {
			// the grouped One Way workbooks (one file per execution, every pickup office), built by the generation service
			path: ONE_WAY_ROUTES.GROUPS_PATH,
			title: ONE_WAY_ROUTES.GROUPS_TITLE,
			subtitle: ONE_WAY_ROUTES.GROUPS_TITLE,
			element: <GroupingExportsPage executionType="one_way_generation" title={ONE_WAY_ROUTES.TITLE} subtitle={ONE_WAY_ROUTES.GROUPS_TITLE}/>,
		}]
	}, {
		// legacy paths, kept so links created before the One Way menu split keep working
		path: ONE_WAY_ROUTES.LEGACY_REPORTS_PATH,
		element: <RedirectWithSearch to={ONE_WAY_ROUTES.REPORTS_PATH}/>,
	}, {
		path: ONE_WAY_ROUTES.LEGACY_ANALYZER_PATH,
		element: <RedirectWithSearch to={ONE_WAY_ROUTES.ANALYZER_PATH}/>,
	}]
}
